export default __webpack_public_path__ + "static/media/Habasit AG.09cf1cfe.png";